<template>
  <div class="home">
    <p>Dub Home</p>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
